<div *ngIf="showable && emptyView" class="jbm-empty-view {{className}}">{{'ui.empty-view'|translate}}</div>